// Role codes — mirror RoleCode in backend assigned-module.entity.ts. Roles
// are compared by code, never by id (ids differ between installations).
export const RoleCode = Object.freeze({
  SchoolAdmin: 'school_admin',
  JhsAdmin: 'jhs_admin',
  ShsAdmin: 'shs_admin',
  Teacher: 'teacher',
  Adviser: 'adviser',
  JhsPrefect: 'jhs_prefect',
  ShsPrefect: 'shs_prefect',
  Parent: 'parent',
  Student: 'student',
  Superadmin: 'superadmin',
});

export const ADMIN_ROLE_CODES = [RoleCode.SchoolAdmin, RoleCode.JhsAdmin, RoleCode.ShsAdmin];
export const PREFECT_ROLE_CODES = [RoleCode.JhsPrefect, RoleCode.ShsPrefect];
export const FACULTY_ROLE_CODES = [RoleCode.Teacher, RoleCode.Adviser];

// Superadmin and Parent are account types, so the account dialogs can't
// grant them (the backend rejects them too). School Administrator is retired
// and Learner hidden (see the backend's NOT_GRANTABLE_ROLES). Adviser is
// granted like any designation and includes Subject Teacher.
export const NON_GRANTABLE_ROLE_CODES = [
  RoleCode.Superadmin,
  RoleCode.Parent,
  RoleCode.SchoolAdmin,
  RoleCode.Student,
];

// School levels: a role's `level` (JHS/SHS, null = both) and an account's
// `levelScope` (which also allows BOTH).
export const SchoolLevel = Object.freeze({ Junior: 'JHS', Senior: 'SHS' });

export const JUNIOR_HIGH_GRADES = ['Grade 7', 'Grade 8', 'Grade 9', 'Grade 10'];
export const SENIOR_HIGH_GRADES = ['Grade 11', 'Grade 12'];

// High-school grades for a role's level; no level = both.
export function gradesForLevel(level) {
  if (level === SchoolLevel.Junior) return JUNIOR_HIGH_GRADES;
  if (level === SchoolLevel.Senior) return SENIOR_HIGH_GRADES;
  return [...JUNIOR_HIGH_GRADES, ...SENIOR_HIGH_GRADES];
}

export const LEVEL_OPTIONS = [
  { value: 'JHS', title: 'Junior High School' },
  { value: 'SHS', title: 'Senior High School' },
  { value: 'BOTH', title: 'Both JHS and SHS' },
];

export function levelLabel(value) {
  return LEVEL_OPTIONS.find((o) => o.value === value)?.title ?? 'Not set';
}

// An account's granted role ids (users.subModules) as numbers.
export function parseRoleIds(raw) {
  if (!raw) return [];
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (Array.isArray(parsed)) return parsed.map(Number);
    // Older rows hold a single id instead of a list.
    return parsed != null && Number.isFinite(Number(parsed)) ? [Number(parsed)] : [];
  } catch {
    return [];
  }
}
